import axios, {
  AxiosResponse,
  AxiosError,
  InternalAxiosRequestConfig,
} from 'axios';
import {tokenService} from './tokenService';

// Create axios instance
const apiClient = axios.create({
  timeout: 45000, // 45 second timeout
});

// Request interceptor to add Bearer token
apiClient.interceptors.request.use(
  async (
    config: InternalAxiosRequestConfig
  ): Promise<InternalAxiosRequestConfig> => {
    try {
      // Get stored token
      const token = tokenService.getStoredToken();

      if (token) {
        // Remove any existing x-functions-key header
        if (config.headers && config.headers['x-functions-key']) {
          delete config.headers['x-functions-key'];
        }

        // Add Authorization header with Bearer token
        config.headers.set('Authorization', `Bearer ${token}`);
        config.headers.set('Content-Type', 'application/json');
      } else {
        console.warn('No access token available for API request');
      }
    } catch (error) {
      console.error('Error setting up request headers:', error);
    }

    return config;
  },
  (error: AxiosError) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle token expiration
apiClient.interceptors.response.use(
  (response: AxiosResponse) => {
    return response;
  },
  async (error: AxiosError) => {
    const originalRequest = error.config;

    // If we get a 401 Unauthorized, clear token and let user know
    if (error.response?.status === 401 && originalRequest) {
      console.log('Token expired or invalid, clearing stored token...');
      tokenService.clearToken();
      // In a real app, you might want to redirect to login or show a message
    }

    return Promise.reject(error);
  }
);

export default apiClient;
